import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import CustomTextArea from "components/CustomTextArea";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import GeneralService from "services/GeneralService";
import { useGlobalContext } from "store/contexts/globalContext";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import ButtonWithProgress from "components/ButtonWithProgress";
import { useToasts } from "react-toast-notifications";
import { useCreatePostContext } from "store/contexts/createPostContext";
import ChatGptAssistModal from "components/ChatGptAssistModal";

export default () => {
  const { team } = useTeamContext();
  const { handleClose } = useCreatePostContext();
  const { teamsClient } = useGlobalContext();
  const { addToast } = useToasts();
  const { createPost } = useTimelineContext();
  const [uploadProgress, setUploadProgress] = useState(0);

  const formik = useFormik({
    initialValues: {
      text: "",
      attachment: null,
    },
    validationSchema: Yup.object().shape(
      {
        text: Yup.string()
          .min(4)
          .max(250, "Topic should not be greater then 250")
          .required(),
        attachment: Yup.mixed().required(),
      },
      ["attachment", "text"]
    ),
    validateOnBlur: false,
    validateOnMount: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        let media = null;

        if (values.attachment) {
          const preSignedResponse = await GeneralService.getPresignedUploadURL({
            filename: values.attachment.name,
            mime_type: values.attachment.type,
            file_size: values.attachment.size,
            resource_type: "team",
            resource_id: team.id,
            resource_policy: "team.celebration",
          });

          const { key, url } = preSignedResponse.data.data;

          media = key;

          await GeneralService.uploadToS3(
            url,
            values.attachment,
            (progress) => {
              setUploadProgress(`${Math.floor(progress)}%`);
            }
          );
        }

        setUploadProgress(100);

        const response = await TeamService.createTeamVideo(
          team.id,
          values.text,
          media
        );

        var attachmentType = values.attachment.type.split("/");

        formik.resetForm();
        setUploadProgress(0);

        if (attachmentType[1] !== "mp4") {
          handleClose();
          addToast(
            "Your post is being processed. We’ll let you know when it’s ready to view. ",
            { appearance: "info" }
          );
          return;
        }

        handleClose();
        createPost(response.data.data);
      } catch (e) {
        console.log(e);
      }
    },
  });

  const onAttachmentSelected = (file) => {
    formik.setFieldValue("attachment", file);
  };

  const clearAttachment = () => {
    formik.setFieldValue("attachment", null);
  };

  const setValue = (value) => {
    formik.setFieldValue("text", value);
  };

  return (
    <section style={{ width: "100%" }}>
      <form noValidate onSubmit={formik.handleSubmit} className="creatingPost">
        <div className="textAttachmentContent">
          <div className="text-area-create-post">
            <ChatGptAssistModal setValue={setValue} />
            <CustomTextArea
              errorClass="textStyle"
              secondErrorClass="textStyle"
              textAreaClass="form-control create-text-padding"
              formik={formik}
              placeholder="Set the Topic for the Team Video"
              fieldName={"text"}
              fieldName2={"attachment"}
            />
          </div>
          {!!formik.values.attachment && (
            <AttachmentPreview
              attachment={formik.values.attachment}
              clearAttachment={clearAttachment}
            />
          )}
        </div>
        <div
          className="writepost-footer"
          style={formik?.errors["attachment"] && { marginTop: "35px" }}
        >
          <div className="writepost-left-btns">
            <ButtonWithProgress
              initialText={"Create"}
              buttonWithProgressClass="send-btn"
              isSubmitting={formik.isSubmitting}
              progress={uploadProgress}
            />
            <AttachmentSelection
              teamsClientVideo={teamsClient}
              selectors={["video", "screen"]}
              showSelectors={true}
              onChange={onAttachmentSelected}
              accepted={[".mp4", ".webm"]}
            />
          </div>
        </div>
      </form>
    </section>
  );
};
